import { BoxIconLine, OrderCompleteIcon } from "../../icons";
import { useOrdersStore } from "../../stores/useOrderStore";

export default function OrderMetrics() {
  const { orders, loading, error } = useOrdersStore();

  const completedOrdersCount = orders.filter(
    (order) => order.status === "SUCCESSFUL"
  ).length;

  // 🌀 Loading state skeletons
  if (loading) {
    return (
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-6">
        {[1, 2].map((i) => (
          <div
            key={i}
            className="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] md:p-6 animate-pulse"
          >
            <div className="h-12 w-12 bg-gray-100 rounded-xl dark:bg-gray-800" />
            <div className="mt-5 space-y-3">
              <div className="h-4 w-1/2 bg-gray-100 rounded" />
              <div className="h-6 w-1/4 bg-gray-100 rounded" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  // ⚠️ Error state
  if (error) {
    return (
      <div className="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] md:p-6 text-red-500">
        {error}
      </div>
    );
  }

  // ✅ Main metrics
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-6">
      {/* Total Orders */}
      <MetricCard
        icon={<BoxIconLine className="size-6 text-gray-800 dark:text-white/90" />}
        title="Total Exchanges"
        value={orders.length}
      />

      {/* Completed Orders */}
      <MetricCard
        icon={
          <OrderCompleteIcon className="size-6 text-gray-800 dark:text-white/90" />
        }
        title="Completed Exchanges"
        value={completedOrdersCount}
      />
    </div>
  );
}

/* 🔹 Small reusable card component */
const MetricCard = ({
  icon,
  title,
  value,
}: {
  icon: React.ReactNode;
  title: string;
  value: number;
}) => (
  <div className="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] md:p-6">
    <div className="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-xl dark:bg-gray-800">
      {icon}
    </div>

    <div className="flex items-end justify-between mt-5">
      <div>
        <span className="text-sm text-gray-500 dark:text-gray-400">{title}</span>
        <h4 className="mt-2 font-bold text-gray-800 text-title-sm dark:text-white/90">
          {value}
        </h4>
      </div>
    </div>
  </div>
);
